export default __webpack_public_path__ + "4b1b2773da5ba965de1b35b703265ee4.svg";